import { ref } from 'vue'
import { defineStore } from 'pinia'

export interface CurrentPlayer {
	id: string
	name: string
	display_name: string
}

export const useAuthStore = defineStore('auth', () => {
	const user = ref<CurrentPlayer | null>(null)
	const loading = ref(true)

	async function fetchMe() {
		try {
			const res = await fetch('/api/me')
			if (res.ok) {
				const data = await res.json()
				user.value = data.payload
			} else {
				user.value = null
			}
		} catch {
			user.value = null
		} finally {
			loading.value = false
		}
	}

	async function signOut() {
		await fetch('/api/me/sign-out', { method: 'POST' })
		user.value = null
	}

	return { user, loading, fetchMe, signOut }
})
